import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingPageService } from '@umss/shared/ui';

export const enum ContractorTabDetailEntity {
  Notification = 'Notification'
}

@Injectable({
  providedIn: 'root'
})
export class ContractorTabTitleService {
  private readonly appName = 'HURO';

  private readonly title = inject(Title);
  private readonly loadingPageService = inject(LoadingPageService);
  constructor() {
    // Listen to loading state changes to update the title accordingly
    this.loadingPageService.navigationEnd$.subscribe((url) => {
      this.setForUrl(url);
    });
    this.setForUrl(window.location.pathname);
  }

  setForUrl(rawUrl: string): void {
    const url = this.normalizeUrl(rawUrl);
    this.setDocumentTitle(this.resolveFallbackTitle(url));
  }

  setDetailTitle(
    entity: ContractorTabDetailEntity | `${ContractorTabDetailEntity}`,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload?: any
  ): void {
    switch (entity) {
      case 'Notification':
        return this.setDocumentTitle(
          `Notification · ${payload?.title || 'Details'}`
        );
      default:
        return this.setDocumentTitle(this.appName);
    }
  }

  private normalizeUrl(rawUrl: string): string {
    return rawUrl.split('?')[0].toLowerCase();
  }

  private resolveFallbackTitle(url: string): string {
    if (url.includes('/dashboard')) return 'Dashboard';
    if (url.includes('/notifications')) return 'Notifications';
    if (url.includes('/schedule')) return 'Schedule';
    if (url.includes('/find-shifts')) return 'Find shifts';
    if (url.includes('/pay')) return 'Payments';
    if (url.includes('/facilities')) return 'Facilities';
    if (url.includes('/availability')) return 'Shift availability';
    if (url.includes('/referrals')) return 'Referrals';
    if (url.includes('/billable-rates')) return 'Billable Rates';
    if (url.includes('/support')) return 'Support';
    if (url.includes('/admin/add')) return 'Add Admin';
    if (url.includes('/admin')) return 'Admins';
    if (url.includes('/settings')) return 'Settings';
    if (url.includes('/profile')) return 'Profile';
    if (url.includes('/auth/login')) return 'Professional portal · Sign in';
    if (url.includes('/auth/register')) return 'Professional portal · Sign up';
    if (url.includes('/auth/terms-of-service'))
      return 'HURO · Terms of Service';

    // Add here any additional URL patterns specific to the corporate module if needed
    return 'HURO · Corporate portal';
  }

  private setDocumentTitle(pageTitle: string): void {
    this.title.setTitle(`${pageTitle}`);
  }
}
